import { Component, Input, OnInit } from '@angular/core';

import { CustomPlaceService } from 'src/app/core/api/services';
import { BaseSelectionList } from '../base/base-selection-list.component';

@Component({
    selector: 'public-place-selection-list',
    templateUrl: './public-place-selection-list.component.html',
    standalone: false
})
export class PublicPlaceSelectionListComponent
  extends BaseSelectionList
  implements OnInit
{
  @Input('sendType') sendType;
  @Input('useType') useType;

  input_searchBoxGridClass = 'tw-w-full';
  input_responsiveClass: string = 'md:tw-w-1/3';
  isSmallSize = true;

  constructor(protected currentService: CustomPlaceService) {
    super();
  }

  ngOnInit() {
    this.initConfig();
    this.getItems();
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'title';
    this.sortKey = 'id';

    if (!this.input_label) this.input_label = 'common.publicPlace';
  }

  getItems() {
    if (this.loading) return;
    this.loading = true;

    this.currentService
      .customPlaceGetCustomPlacesByOrganization({})
      .pipe(this.baseSelectionSearchPipeOperators)
      .subscribe((items) => {
        this.items = items?.data;
      });
  }
}
